/*
 const API_PORT = 44396
// const API_PORT = 8888 // pruebas actualmente en 2023
 //const API_PORT = 92 // productivo actualmente en 2023


export const API_SERVER = 
(window.location.hostname === "localhost") ? `https://localhost:${API_PORT}/` :
(window.location.hostname.startsWith('192.168.')) ? `
https://192.168.8.89:${API_PORT}/` :
`https://www.interamerican.gt:${API_PORT}`;

*/



//const API_PORT = 44396 // pruebas localddddd
// const API_PORT = 8888 // pruebas actualmente en 2023
const API_PORT = 92 // productivo server cliente

//const API_PORT = 82 // pruebas server cliente

const HttpsSettings = (API_PORT === 82)? 'http':'https';
 
export const API_SERVER = 
(window.location.hostname === "localhost") ? `${HttpsSettings}://localhost:${API_PORT}` :
(window.location.hostname.startsWith('192.168.')) ? `
https://190.56.108.171:${API_PORT}/` :
`https://www.interamerican.gt:${API_PORT}`;

